module.exports = __webpack_public_path__ + "img/px_up.9ce932b2.svg";